const routes = {
    "/" : "/",
    //"index" : "/fooldal",
    "index" : "/",
    //"introduction" : "/#introduction",
    "introduction" : "/#bemutatkozas",
    "apartments" : "/elado-lakasok",
    "apartment" : "/elado-lakas/:id",
    "paymentInformations" : "/ertekesites",
    "documents" : "/dokumentumok",
    //"contact" : "/contact",
    "contact" : "/#kapcsolat",
    "gallery" : "/galeria",
    "blogListings" : "/hirek",
    "blogSingle" : "/hirek/:slug",
    "admin" : "/admin",
    "login" : "/admin",
    "dashboard" : "/admin/dashboard",

    //Adott routeokhoz tartozó meta beállítások
    "helmet" : {
        "/" : {
            "name" : "Főoldal",
            "title" : "Eladó új építésű lakások Budapesten a 13. kerületben",
            "metaDescription" : "Eladó új építésű lakások Budapesten a 13. kerületben a Csángó 10 társasházban. Válogasson korszerű eladó lakásaink között és foglaljon időpontot nálunk.",
        },
        "index" : {
            "name" : "Főoldal",
            "title" : "Eladó új építésű lakások Budapesten a 13. kerületben",
            "metaDescription" : "Eladó új építésű lakások Budapesten a 13. kerületben a Csángó 10 társasházban. Válogasson korszerű eladó lakásaink között és foglaljon időpontot nálunk.",
        },
        "apartments" : {
            "name" : "Lakások",
            "title" : "Lakások",
            "metaDescription" : "Garzonlakástól, több szobás otthonig válogathatsz eladó és kiadó lakásaink közül új építésű társasházunkban a Csángó 10-ben",
        },
        "apartment" : {
            //"title" : "Lakás {apartmentCode}", //pages/Apartment.js
            "metaDescription" : "Csángó 10 társasház, ahol az otthonod épül. Új építésű eladó lakások Budapesten, a 13. kerületben, kedvező áron, finanszírozással, közvetlenül a fejlesztőtől",
        },
        "paymentInformations" : {
            "name" : "Értékesítés",
            "title" : "Lakás Értékesítés",
            "metaDescription" : "Érdeklődjön még ma lakásaink felől kollégáinknál.",
        },
        "documents" : {
            "name" : "Dokumentumok",
            "title" : "Dokumentumok",
            "metaDescription" : "Tekintsd meg lakáskínálatunkat, magas műszaki tartalommal, részletes alaprajzokkal, látványtervekkel. Budapest 13. kerülete és új építésű lakásaink téged várnak",
        },
        "contact" : {
            "name" : "Kapcsolat",
            "title" : "Kapcsolat",
            "metaDescription" : "Kapcsolat meta description",
        },
        "introduction" : {
            "name" : "Bemutatkozás",
            "title" : "Bemutatkozás",
            "metaDescription" : "Kapcsolat meta description",
        },
        "gallery" : {
            "name" : "Galéria",
            "title" : "Galéria",
            "metaDescription" : "Csángó 10 társasház, ahol az otthonod épül. Új építésű eladó lakások Budapesten, a 13. kerületben, kedvező áron, finanszírozással, közvetlenül a fejlesztőtől",
        },
        "blogListings" : {
            "name" : "Hírek",
            "title" : "Hírek",
            "metaDescription" : "Csángó 10 társasház, ahol az otthonod épül. Új építésű eladó lakások Budapesten, a 13. kerületben, kedvező áron, finanszírozással, közvetlenül a fejlesztőtől",
        },
        "blogSingle" : {
            "name" : "Hírek",
            "title" : "Hírek",
            "metaDescription" : "Csángó 10 társasház, ahol az otthonod épül. Új építésű eladó lakások Budapesten, a 13. kerületben, kedvező áron, finanszírozással, közvetlenül a fejlesztőtől",
        },

        "default" : {
            "name" : "Eladó lakások",
            "title" : "Eladó lakások",
            "metaDescription" : "Csángó 10 társasház, ahol az otthonod épül. Új építésű eladó lakások Budapesten, a 13. kerületben, kedvező áron, finanszírozással, közvetlenül a fejlesztőtől",
        }
    }
}

export default routes;